module.exports = __webpack_public_path__ + "img/help1-1-2.ca027bf2.png";